import { RegionAuthGuard } from './../shared/services/region-auth-guard.service';
import { AuthGuard } from './../shared/services/auth-guard.service';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RegionComponent } from './region.component';
import { HomeComponent } from './components/home/home.component';
import { SanctionedPostListComponent } from './components/sanctioned-post/sanctioned-post-list/sanctioned-post-list.component';
import { SanctionedPostFormComponent } from './components/sanctioned-post/sanctioned-post-form/sanctioned-post-form.component';
import { VacantPostListComponent } from './components/vacant-post/vacant-post-list/vacant-post-list.component';
import { VacantPostFormComponent } from './components/vacant-post/vacant-post-form/vacant-post-form.component';
import { EmployeeListComponent } from './components/employee/employee-list/employee-list.component';
import { TransferRequestListComponent } from './components/transfer-request/transfer-request-list/transfer-request-list.component';
import { TransferRequestViewComponent } from './components/transfer-request-view/transfer-request-view.component';

import { ProfileContactFormComponent } from './components/employee/profile-contact-form/profile-contact-form.component';
import { ProfileFormComponent } from './components/employee/profile-form/profile-form.component';

import { ServiceBookListComponent } from './components/employee/service-book/service-book-list/service-book-list.component';
import { ServiceBookFormComponent } from './components/employee/service-book/service-book-form/service-book-form.component';
import { PresentPlaceFormComponent } from './components/employee/service-book/present-place-form/present-place-form.component';
import { EmployeeProfileListComponent } from './components/employee-profile/employee-profile-list/employee-profile-list.component';
import { EmployeeProfileViewComponent } from './components/employee-profile/employee-profile-view/employee-profile-view.component';
import { ViewEmployeeProfileComponent } from './components/employee/view-employee-profile/view-employee-profile.component';

const routes: Routes = [
  {
    path: '',
    data: { breadcrumb: "Admin" },
    component: RegionComponent,
    canActivate: [AuthGuard, RegionAuthGuard],
    children: [
      {
        path: '',
        data: { breadcrumb: 'Home' },
        component: HomeComponent
      },
      {
        path: 'sanctioned-posts',
        data: { breadcrumb: "Sanctioned Posts" },
        children: [
          { path: '', component: SanctionedPostListComponent, data: { breadcrumb: "Sanctioned Posts" } },
          { path: 'new', component: SanctionedPostFormComponent, data: { breadcrumb: "New" } },
          { path: 'edit/:id', component: SanctionedPostFormComponent, data: { breadcrumb: "Edit" } },
          {
            path: 'vacant-posts',
            data: { breadcrumb: "Vacant Posts" },
            children: [
              { path: '', component: VacantPostListComponent, data: { breadcrumb: "Vacant Posts" } },
              { path: 'new', component: VacantPostFormComponent, data: { breadcrumb: "New" } },
              { path: 'edit/:id', component: VacantPostFormComponent, data: { breadcrumb: "Edit" } }
            ]
          },
        ]
      },
      {
        path: 'employees',
        data: { breadcrumb: "Employees" },
        children: [
          { path: '', component: EmployeeListComponent, data: { breadcrumb: "Employees" } },
          { path: 'edit/:id/:financialYearId', component: ProfileFormComponent, data: { breadcrumb: "Edit Employee Profile" } },
          { path: 'edit-contact/:id/:financialYearId', component: ProfileContactFormComponent, data: { breadcrumb: "Edit Employee Contact Details" } },
          { path: 'view/:profileId/:financialYearId', component: TransferRequestViewComponent, data: { breadcrumb: "Edit Employee" } },
           { path: 'viewprofile/:profileId/:financialYearId', component: ViewEmployeeProfileComponent, data: { breadcrumb: "Edit Employee Profile" } },
          { path: 'transfer-requests', component: TransferRequestListComponent, data: { breadcrumb: "Transfer Requests" } },
          { path: 'transfer-request/:profileId/:financialYearId/:phaseId', component: TransferRequestViewComponent, data: { breadcrumb: "View Transfer Request" } },
          {
            path: 'service-book',
            data: { breadcrumb: "Service Book" },
            children: [
              { path: ':profileId/:financialYearId', component: ServiceBookListComponent, data: { breadcrumb: "Service Book" } },
              { path: 'present-place/:profileId/:financialYearId', component: PresentPlaceFormComponent, data: { breadcrumb: "Present Place" } },
              { path: 'new/:profileId/:financialYearId', component: ServiceBookFormComponent, data: { breadcrumb: "New" } },
              { path: 'edit/:profileId/:id/:financialYearId', component: ServiceBookFormComponent, data: { breadcrumb: "Edit" } }
            ]
          },
        ]
      },
      {
        path: 'employee-profile',
        data: { breadcrumb: "Employee Profile" },
        children: [
          { path: '', component: EmployeeProfileListComponent, data: { breadcrumb: "Employee Profile" } },
          { path: 'view-profile/:profileId/:financialYearId', component: EmployeeProfileViewComponent, data: { breadcrumb: "View Profile" } }
        ]
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RegionRoutingModule { }
